import { Route, Switch } from 'react-router-dom';
import { lazy, Suspense } from 'react';


const RST01 = lazy(() => import('@/pages/E01/RST01'));  // FAQ
const RST02 = lazy(() => import('@/pages/E01/RST02'));  // QNA
const RST03 = lazy(() => import('@/pages/E01/RST03'));  // FAQ


function E01() {
  return ( 
    <Suspense fallback={null}>
      <Switch>
        <Route path="/E01/RST01" component={RST01} />
        <Route path="/E01/RST02" component={RST02} />
        <Route path="/E01/RST03" component={RST03} />
      </Switch>
    </Suspense>
  );
}

export default E01;
